// Mock data for author's books
export const authorBooks = [
  {
    id: '1',
    title: 'The Silent Echo',
    series: 'Echo Series',
    seriesNumber: 1,
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    color: 'bg-gradient-to-r from-indigo-500 to-purple-600',
    releaseDate: '2021-05-15',
    genre: 'Mystery Thriller',
    edition: 'standard',
    type: 'series',
    format: 'paperback',
    rating: 4.5,
    description:
      'A gripping thriller that follows detective Sarah Miller as she investigates a series of mysterious disappearances in a small coastal town.',
  },
  {
    id: '2',
    title: 'Broken Echoes',
    series: 'Echo Series',
    seriesNumber: 2,
    coverImage:
      'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    color: 'bg-gradient-to-r from-purple-500 to-indigo-600',
    releaseDate: '2022-01-20',
    genre: 'Mystery Thriller',
    edition: 'special',
    type: 'series',
    format: 'hardcover',
    rating: 4.7,
    description:
      'Detective Sarah Miller returns to face her most challenging case yet as echoes from her past threaten to unravel everything.',
  },
  {
    id: '3',
    title: 'Final Echo',
    series: 'Echo Series',
    seriesNumber: 3,
    coverImage:
      'https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    color: 'bg-gradient-to-r from-blue-500 to-indigo-600',
    releaseDate: '2022-08-10',
    genre: 'Mystery Thriller',
    edition: 'standard',
    type: 'series',
    format: 'paperback',
    rating: 4.6,
    description:
      'The thrilling conclusion to the Echo Series as Detective Miller confronts her darkest fears and most dangerous adversary yet.',
  },
  {
    id: '4',
    title: 'Whispers in the Dark',
    series: '',
    seriesNumber: null,
    coverImage:
      'https://images.unsplash.com/photo-1598646506899-ac6be1060f4b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    color: 'bg-gradient-to-r from-gray-700 to-gray-900',
    releaseDate: '2020-10-31',
    genre: 'Horror',
    edition: 'standard',
    type: 'standalone',
    format: 'ebook',
    rating: 4.3,
    description:
      'A chilling tale of supernatural encounters in an abandoned Victorian mansion that has been shunned by locals for generations.',
  },
  {
    id: '5',
    title: 'Midnight Shadows',
    series: '',
    seriesNumber: null,
    coverImage:
      'https://images.unsplash.com/photo-1515876305430-f06edab8282a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    color: 'bg-gradient-to-r from-gray-800 to-blue-900',
    releaseDate: '2019-06-15',
    genre: 'Supernatural Thriller',
    edition: 'special',
    type: 'standalone',
    format: 'paperback',
    rating: 4.1,
    description:
      "When strange shadows begin appearing in a small New England town, residents must confront long-buried secrets before it's too late.",
  },
  {
    id: '6',
    title: 'Heart of the Storm',
    series: 'Elements Trilogy',
    seriesNumber: 1,
    coverImage:
      'https://images.unsplash.com/photo-1516979187457-637abb4f9353?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    color: 'bg-gradient-to-r from-blue-400 to-blue-600',
    releaseDate: '2020-03-22',
    genre: 'Fantasy Romance',
    edition: 'standard',
    type: 'series',
    format: 'paperback',
    rating: 4.8,
    description:
      'In a world where elemental magic determines social status, a young woman with extraordinary storm powers must navigate court intrigue and forbidden romance.',
  },
  {
    id: '7',
    title: 'Soul of Fire',
    series: 'Elements Trilogy',
    seriesNumber: 2,
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    color: 'bg-gradient-to-r from-red-500 to-orange-500',
    releaseDate: '2021-01-15',
    genre: 'Fantasy Romance',
    edition: 'special',
    type: 'series',
    format: 'hardcover',
    rating: 4.9,
    description:
      'As war looms on the horizon, our heroine must master the fire within her soul while protecting those she loves from mounting dangers.',
  },
  {
    id: '8',
    title: 'Breath of Earth',
    series: 'Elements Trilogy',
    seriesNumber: 3,
    coverImage:
      'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    color: 'bg-gradient-to-r from-green-500 to-teal-500',
    releaseDate: '2021-11-30',
    genre: 'Fantasy Romance',
    edition: 'standard',
    type: 'series',
    format: 'paperback',
    rating: 4.7,
    description:
      'The epic conclusion to the Elements Trilogy where earth magic and ancient prophecies collide in a battle for the fate of the world.',
  },
  {
    id: '9',
    title: 'Tales of Darkness',
    series: 'Midnight Anthology',
    seriesNumber: 1,
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    color: 'bg-gradient-to-r from-gray-900 to-purple-900',
    releaseDate: '2022-10-31',
    genre: 'Horror',
    edition: 'special',
    type: 'anthology',
    format: 'hardcover',
    rating: 4.4,
    contributors: ['Elena Richards', 'James Morgan', 'Sarah Chen'],
    description:
      'A collection of chilling tales from multiple authors exploring the darkest corners of human fear and supernatural terror.',
  },
  {
    id: '10',
    title: 'Shadows Rising',
    series: 'Midnight Anthology',
    seriesNumber: 2,
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    color: 'bg-gradient-to-r from-purple-900 to-indigo-900',
    releaseDate: '2023-04-15',
    genre: 'Horror',
    edition: 'standard',
    type: 'anthology',
    format: 'paperback',
    rating: 4.5,
    contributors: ['Elena Richards', 'James Morgan', 'Sarah Chen', 'David Lee'],
    description:
      'The second volume in the acclaimed Midnight Anthology series, featuring new stories of horror and the macabre from celebrated authors.',
  },
  {
    id: '11',
    title: 'The Lost City',
    series: '',
    seriesNumber: null,
    coverImage:
      'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    color: 'bg-gradient-to-r from-amber-600 to-red-600',
    releaseDate: '2021-07-12',
    genre: 'Adventure',
    edition: 'special',
    type: 'cowrite',
    format: 'hardcover',
    rating: 4.6,
    coAuthor: 'Marcus Blackwood',
    description:
      "An archaeologist's discovery of an ancient map leads to a dangerous expedition into the uncharted jungle in search of a legendary lost city.",
  },
  {
    id: '12',
    title: 'Secrets of the Deep',
    series: '',
    seriesNumber: null,
    coverImage:
      'https://images.unsplash.com/photo-1551029506-0807df4e2031?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    color: 'bg-gradient-to-r from-cyan-600 to-blue-700',
    releaseDate: '2022-03-08',
    genre: 'Adventure',
    edition: 'standard',
    type: 'cowrite',
    format: 'ebook',
    rating: 4.2,
    coAuthor: 'Marcus Blackwood',
    description:
      'A deep-sea exploration uncovers mysteries beneath the waves that should have remained hidden, in this thrilling collaboration with Marcus Blackwood.',
  },
]
